import React, { useContext, useEffect, useState } from "react";
import { Col, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { BsArrowDown } from "react-icons/bs";
import { useHistory } from "react-router-dom";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";
import TextSpinner from "../../../../components/UI/Spinner/TextSpinner";
import { AuthContext, funcionalidades } from "../../../../context/AuthContext";

const motivoBloqueioAlteracao = (row) => {
  if (row.stCiencia === "S") return "Ciência sem efeito não pode ser alterada";
  if (row.tpModoCiencia === "D") return "Ciência modo DTE não pode ser alterada";
  return null;
};

const wrapWithTooltip = (cell, motivo) =>
  motivo ? (
    <OverlayTrigger placement="top" overlay={<Tooltip>{motivo}</Tooltip>}>
      <span style={{ display: "inline-block" }} data-tag="allowRowEvents">
        {cell}
      </span>
    </OverlayTrigger>
  ) : (
    cell
  );

const buildCienciaColumns = (podeAdministrar) => [
  {
    name: "Momento",
    cell: (row) => wrapWithTooltip(row.dsMomentoAnalisado, podeAdministrar ? motivoBloqueioAlteracao(row) : null),
    sortable: true,
    selector: (row) => row.dsMomentoAnalisado,
    width: "20%",
  },
  {
    name: "Modo Ciência",
    cell: (row) => wrapWithTooltip(row.dsTpModoCiencia, podeAdministrar ? motivoBloqueioAlteracao(row) : null),
    selector: (row) => row.dsTpModoCiencia,
    center: true,
    width: "15%",
  },
  {
    name: "Data Ciência",
    cell: (row) => wrapWithTooltip(row.dtCiencia, podeAdministrar ? motivoBloqueioAlteracao(row) : null),
    selector: (row) => row.dtCiencia,
    center: true,
    width: "15%",
  },
  {
    name: "CPF",
    cell: (row) => wrapWithTooltip(row.nuCpf, podeAdministrar ? motivoBloqueioAlteracao(row) : null),
    selector: (row) => row.nuCpf,
    center: true,
    width: "15%",
  },
  {
    name: "Nome",
    cell: (row) => wrapWithTooltip(row.nmContribuinte, podeAdministrar ? motivoBloqueioAlteracao(row) : null),
    selector: (row) => row.nmContribuinte,
    width: "20%",
  },
  {
    name: "Status",
    cell: (row) => wrapWithTooltip(row.dsStCiencia, podeAdministrar ? motivoBloqueioAlteracao(row) : null),
    selector: (row) => row.dsStCiencia,
    center: true,
    width: "15%",
  },
];

const PatDetalhesExpandido = ({ data }) => {
  const [ciencias, setCiencias] = useState([]);
  const history = useHistory();
  const { isAllowed } = useContext(AuthContext);
  const podeAdministrar = isAllowed(funcionalidades.pat.cienciaIncluir);
  const cienciaColumns = buildCienciaColumns(podeAdministrar);

  const { request: requestCiencias, data: dataCiencias, isLoading: loadingCiencias } = useApiClient();

  useEffect(() => {
    if (data.sqProcesso) {
      requestCiencias(apiRoutes.fiscalizacao.pat.listaMomentoCiencia, { SqProcesso: data.sqProcesso });
    }
  }, [data.sqProcesso, requestCiencias]);

  useEffect(() => {
    if (dataCiencias?.result) {
      setCiencias(dataCiencias.result || []);
    }
  }, [dataCiencias]);

  const formatarNuPat = (cdProcesso) => {
    if (!cdProcesso) return "";
    const parts = cdProcesso.split("/");
    if (parts.length !== 2) return cdProcesso;
    return `${parts[0].slice(-4)}/${parts[1]}`;
  };

  const handleRowClicked = (row) => {
    if (!podeAdministrar) return;
    if (motivoBloqueioAlteracao(row)) return;
    history.push({
      pathname: history.location.pathname.replace(/\/[^/]+$/, "") + "/editarCiencia",
      state: {
        sqProcesso: data.sqProcesso,
        cdProcesso: formatarNuPat(data.cdProcesso),
        sqAcaoFiscal: data.sqAcaoFiscal,
        ciencia: row,
      },
    });
  };

  const conditionalRowStyles = [
    {
      when: (row) => podeAdministrar && !motivoBloqueioAlteracao(row),
      style: { cursor: "pointer" },
    },
  ];

  return (
    <div style={{ padding: "10px 20px" }}>
      <Row>
        <Col>
          <h6 className="font-weight-bold text-primary mb-2">Ciências Registradas</h6>
          <DataTable
            noHeader
            keyField="sqMomentoCiencia"
            columns={cienciaColumns}
            data={ciencias}
            progressPending={loadingCiencias}
            noDataComponent="Nenhuma ciência registrada"
            progressComponent={<TextSpinner />}
            sortable
            sortIcon={<BsArrowDown />}
            dense
            onRowClicked={handleRowClicked}
            conditionalRowStyles={conditionalRowStyles}
          />
        </Col>
      </Row>
    </div>
  );
};

export default PatDetalhesExpandido;
